import { BilledPeriods, PopulationList, ConsumerJourney, SegmentPopulation } from "@models/population.model";
import { CommandGetBilledPeriods } from "./commands/cmdGetBilledPeriods";
import { CommandGetPopulation } from "./commands/cmdGetPopulation";
import { CommandGetConsumerJourney } from "./commands/cmdGetConsumerJourney";
import { CommandGetSegmentConsumerJourney } from "./commands/cmdGetSegmentConsumerJourney";
import { CommandSetControlGroup } from "./commands/cmdSetControlGroup";
import { CommandGetSegmentPopulation, type RosterFilters } from "./commands/cmdGetSegmentPopulation";
import { CommandSetSegmentControlGroup } from "./commands/cmdSetSegmentControlGroup";
import { CommandSetSegmentChannelHoldout } from "./commands/cmdSetSegmentChannelHoldout";
import { CommandResetSegmentData, ResetSegmentDataOptions } from "./commands/cmdResetSegmentData";

export class PopulationService {
  async getPopulation(
    launchId: number,
    limit: number = 50,
    offset: number = 0,
    audienceId: number | null = null,
    consumerId: number | null = null,
    controlMode: string | null = null,
  ): Promise<PopulationList> {
    return await new CommandGetPopulation().run(launchId, limit, offset, audienceId, consumerId, controlMode);
  }

  async getConsumerJourney(launchId: number, consumerId: number): Promise<ConsumerJourney> {
    return await new CommandGetConsumerJourney().run(launchId, consumerId);
  }

  async getSegmentConsumerJourney(
    populationSegmentId: number,
    consumerId: number,
  ): Promise<ConsumerJourney> {
    return await new CommandGetSegmentConsumerJourney().run(populationSegmentId, consumerId);
  }

  async setControlGroup(launchId: number, enabled: boolean, pct: number): Promise<PopulationList> {
    return await new CommandSetControlGroup().run(launchId, enabled, pct);
  }

  async getSegmentPopulation(
    populationSegmentId: number,
    limit = 50,
    offset = 0,
    controlMode: string | null = null,
    testMode: string | null = null,
    filters: RosterFilters = {},
  ): Promise<SegmentPopulation> {
    return await new CommandGetSegmentPopulation().run(
      populationSegmentId, limit, offset, controlMode, testMode, filters,
    );
  }

  async resetSegmentData(
    populationSegmentId: number,
    options: ResetSegmentDataOptions = {},
  ): Promise<{ job_id: number }> {
    return await new CommandResetSegmentData().run(populationSegmentId, options);
  }

  async getBilledPeriods(populationSegmentId: number): Promise<BilledPeriods> {
    return await new CommandGetBilledPeriods().run(populationSegmentId);
  }

  async setSegmentControlGroup(
    populationSegmentId: number,
    enabled: boolean,
    pct: number,
  ): Promise<SegmentPopulation> {
    return await new CommandSetSegmentControlGroup().run(populationSegmentId, enabled, pct);
  }

  async setSegmentChannelHoldout(
    populationSegmentId: number,
    channel: string,
    enabled: boolean,
    pct: number,
  ): Promise<SegmentPopulation> {
    return await new CommandSetSegmentChannelHoldout().run(populationSegmentId, channel, enabled, pct);
  }

}
